function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("style", null, ".full-extent_svg__st0{fill:#333}");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "full-extent_svg__st0",
  d: "M574.9 19.2c232.2-.9 392.9 148.1 412 336.6 21.3 209.9-121.6 382.8-315.4 414.7-84.8 13.9-165.8 0-241.3-41.5-13.9-7.6-22.3-6.7-33.9 4.9-78 78.3-156.2 156.4-235.7 233.1-43.5 42-108.4 29.2-135.9-24.6-14.5-28.3-9.8-67.6 13.4-92.1 36.2-38.3 73.4-75.7 110.5-113.1 42-42.4 83.9-84.9 126.7-126.6 10.5-10.2 11.6-17.8 4.8-30.8-62.5-119.9-66.7-241.7-1.8-361 71.3-131 185.4-195.3 296.6-199.6zm34.4 646.9c144.8 1.1 266.8-118.5 271.8-258.9 5.3-148.9-119.3-280.5-268.3-280.2-148.8.3-267.5 118.5-271.3 267.1-3.7 144.9 123.7 275.7 267.8 272z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "full-extent_svg__st0",
  d: "M611 344.4c36.8 0 73.6-.4 110.3.1 29 .4 49.3 20 51 48 1.8 30.8-15.9 55.6-46.1 56.3-76.7 1.7-153.4 1.7-230.1.1-29.2-.6-48.7-27.1-46.7-56.2 1.9-28 23.4-48.1 53.1-48.5 36.1-.4 72.3-.1 108.4-.1.1.1.1.2.1.3z"
});

var SvgFullExtent = function SvgFullExtent(props) {
  return React.createElement("svg", _extends({
    id: "full-extent_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "0c8ccf8360f6ab94b7ccca334528f144.svg";
export { SvgFullExtent as ReactComponent };